import * as React from 'react'
import { SVGProps } from 'react'
const SvgNecklaces = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 20 20" {...props}>
    <path d="M17.576 0C15.84 1.575 13.305 3.095 10 3.095 6.705 3.095 4.176 1.592 2.422 0H.75a14.625 14.625 0 0 0 3.393 2.695 11.888 11.888 0 0 0 4.103 1.442 2.008 2.008 0 0 0 1.168 2.88v1.085H7.985v2.079H5.958v4.038h2.027V20h4.03v-5.781h2.027V10.18h-2.027V8.1h-1.429V7.017a2.008 2.008 0 0 0 1.168-2.88 11.86 11.86 0 0 0 3.965-1.364C16.988 2.071 18.175 1.14 19.25 0h-1.674Zm-6.733 9.276v2.079h2.027v1.69h-2.027v5.78H9.157v-5.78H7.13v-1.69h2.027v-2.08h1.686ZM10 5.93a.83.83 0 0 1 0-1.66.83.83 0 0 1 0 1.66Z" />
  </svg>
)
export default SvgNecklaces
